export class CaseDetails {



  Operation: String = "New";
  CompanyName: String = "KCI";
  SRNumber: String = "";
  FirstName: String = "";
  LastName: String = "";
  ContactTitle: String = "";
  Address1: String = "";
  Address2: String = "";
  City: String = "";
  State: String = "";
  Country: String = "Canada";
  Zip: String = "";
  Phone: String = "";
  ContactEmail: String;
  VIN: String = "";
  Mileage: String = "";
  DealerCode: String = "";
  Category: String = "";
  SubCategory: String = "";
  Description: String = "";
  Model: String = "";
  ModelYear: String = "";
  AttachmentsDetails: AttachmentsDetails[];
  ListOfFinServiceRequestNotes: ListOfFinServiceRequestNotes;
}
export class Case {
  CaseDetails: CaseDetails;
}
export class AttachmentsDetails {
  FileName: String;
  AttDescription: String;
}
export class ArrAttachmentsDetails {
  FileId: String;
  FileName: String;
  AttDescription: String;
  TodaysDate: String;
  public ArrAttachmentsDetails: ArrAttachmentsDetails[];
}
export class Results {
  success: String;

}

export class ListOfFinServiceRequestNotes {
  FinServiceRequestNotes: FinServiceRequestNotes[];
}

export class FinServiceRequestNotes {
  NoteCreated: string;
  NoteDescription: string;
  SRNumber: string;
}

export class DealerInfo {
  KMS: string;
  PostalCode: string;
  DealerCode: string;
  DealerName: string;
  DealerAddress: string;
  DealerTel: string;
}

export class Dealer {
  dealerInfo: DealerInfo[];
}
